import Immutable from 'immutable';
import {
  FLAG_GETTING_CITIES,
  GET_CITIES,
  CLEAR_CITIES,
  FLAG_CITY_ACTIVITY,
  GET_CITY,
  CLEAR_CITY,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';


const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    error: null,
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, {type,payload}) => {
  switch (type) {
    case FLAG_GETTING_CITIES:
      return state.setIn(['all', 'loading'], payload);
    case GET_CITIES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_CITIES:
      return state.setIn(['all', 'content'], INITIAL_STATE.getIn(['all', 'content']));
    case FLAG_CITY_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_CITY:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_CITY:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
